import React from 'react';
import { AppBar, Toolbar, Box, Typography, IconButton } from '@mui/material';
import { Home, Book, Settings as SettingsIcon, Storage } from '@mui/icons-material';
import { Link, useLocation } from 'react-router-dom';
import './NavBar.css';

interface NavBarProps {
  onSettingsClick: () => void;
}

const NavBar: React.FC<NavBarProps> = ({ onSettingsClick }) => {
  const location = useLocation();
  const isActive = (path: string) => location.pathname === path;

  return (
    <AppBar position="fixed" sx={{ backgroundColor: 'white' }}>
      <Toolbar sx={{ padding: 0, minHeight: '72px !important' }}>
        <Box sx={{ display: 'flex', width: '100%', position: 'relative', alignItems: 'center' }}>
          <Box
            component={Link}
            to="/"
            sx={{
              width: '25%',
              textAlign: 'center',
              color: isActive('/') ? '#000' : '#666',
            }}
            className={`nav-link ${isActive('/') ? 'active' : ''}`}
          >
            <Home />
            <Typography variant="caption">
              Home
            </Typography>
          </Box>
          <Box
            component={Link}
            to="/details"
            sx={{
              width: '25%',
              textAlign: 'center',
              color: isActive('/details') ? '#000' : '#666',
            }}
            className={`nav-link ${isActive('/details') ? 'active' : ''}`}
          >
            <Book />
            <Typography variant="caption">
              Details
            </Typography>
          </Box>
          <Box
            component={Link}
            to="/training-data"
            sx={{
              width: '25%',
              textAlign: 'center',
              color: isActive('/training-data') ? '#000' : '#666',
            }}
            className={`nav-link ${isActive('/training-data') ? 'active' : ''}`}
          >
            <Storage />
            <Typography variant="caption">
              Training Data
            </Typography>
          </Box>
          <Box sx={{ width: '25%', textAlign: 'center' }}>
            <IconButton onClick={onSettingsClick} color={isActive('/settings') ? 'primary' : 'default'}>
              <SettingsIcon />
            </IconButton>
          </Box>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default NavBar;
